import $ from 'jquery';
import bodyScroll from '../scripts/bodyScroll';
import breakpoint from '../scripts/breakpoint';
import shared from '../scripts/shared';

$.addInit(function(context){
	var base = '.b-head';
	$(base, context).each(function(){
		var component = $(this);
		var humburger = component.find('.b-humburger');
		var menuWrap = component.find(base + '-nav');
		var menu = component.find('.b-menu');
		var menuAction = component.find('.b-menu-action');
		var isActive = false;

		function setActive(value) {
			component.toggleClass('m-active', value);
			$(document)[value ? 'on' : 'off']('click', closeHandler);

			isActive = value;

			if (isActive) {
				bodyScroll.disable(menu.get(0), {reserveScrollBarGap: true});
			} else {
				bodyScroll.enable(menu.get(0));
			}
		}

		function toggleHandler(e) {
			e.preventDefault();

			if (!humburger.hasClass('m-active')) {
				setTimeout(function() {
					setActive(true);
				});
			} else {
				setTimeout(function() {
					setActive(false);
				});
			}
		}

		function closeHandler(e) {
			if ($(e.target).closest(component).length === 0) {
				setActive(false);
			}
		}

		breakpoint(null, 'lg')
			.onmatch(function(){
				humburger.on('click', toggleHandler);
				menuAction.on('click', function() {
					setActive(false);
				});
			})
			.onmismatch(function() {
				humburger.off('click', toggleHandler);
				menuAction.off('click', function() {
					setActive(false);
				});
			});

		shared.headerHeight = component.height();
	});
});
